angular.module("legaleRappresentante.components", [])
  .component("legaleRappresentante", {
    templateUrl: 'ng/components/userManagementAra/legaleRappresentante/legaleRappresentante.html',
    bindings: {
      dealerCustomer: "<"
    },
    controller: legaleRappresentanteController,
    controllerAs: 'legaleRappCtrl'
  })

function legaleRappresentanteController(
  $userService,
  $timeout,
  validationService
) {
  var self = this;

  self.$onInit = function () {
    self.modifyInfo = false
    self.codiceFiscaleOk = true;
  }

  self.enableModify = function () {
    self.legaleRapp = Object.assign({}, self.dealerCustomer);
    self.modifyInfo = true
  }

  self.goBack = function () {
    self.modifyInfo = false
  }

  self.handleChange = function (value, property) {
    if (property == 'cf') {
      self.legaleRapp.identifier = value;
    }
    self.legaleRapp[property] = value;
    $timeout(function () {
      self.codiceFiscaleOk = validationService.checkCfWithName(self.legaleRapp.cf, self.legaleRapp.surname, self.legaleRapp.name);
    }, 500)
  }

  self.saveInfo = function () {
    self.isSaving = true
    $userService.updateAppUserGeneral(self.legaleRapp)
      .then(function (response) {
        if (response.success) {
          jQuery.each(self.dealerCustomer, function (key) {
            self.dealerCustomer[key] = self.legaleRapp[key]
          });
          self.modifyInfo = false
        }
        self.isSaving = false
      })
      .catch(function (err) {
        console.log(err)
        self.isSaving = false
      })
  }

}